import { Box, styled } from '@mui/material';

export const RichTextEditorBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  '& .ck.ck-content': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable)': {
    borderRadius: '8px 8px 0 0 !important',
  },
  '& .ck.ck-content.ck-editor__editable': {
    paddingTop: '3px',
    paddingBottom: '3px',
    border: '0px solid transparent',
  },
}));

export const EditCommentBox = styled(Box)((_) => ({
  display: 'flex',
  flexDirection: 'column',
  '& .MuiBox-root': {
    marginBottom: '16px',
  },
  '& .ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable)': {
    borderRadius: 0,
    backgroundColor: 'transparent',
    width: '100%',

    '& > p': { marginTop: 0 },
  },
  '& .ck.ck-content.ck-editor__editable': {
    padding: 0,
  },
  '& .MuiButtonBase-root': {
    paddingLeft: '32px',
    paddingRight: '32px',
  },
}));

export const CommentsListBox = styled(Box)((_) => ({
  height: '100%',
  ul: { padding: 0 },
  li: { flexDirection: 'column', alignItems: 'flex-start', padding: '0' },
  '& .MuiBox-root': { display: 'flex', alignItems: 'center', width: '100%' },
}));

export const EmptyBox = styled(Box)((_) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'text.secondary',
}));
